import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import jobActions from 'actions/jobs'
import assetActions from 'actions/assets'
import operatorActions from 'actions/operators'
import tagListActions from 'actions/tagLists'
import productActions from 'actions/products'
import orderItemActions from 'actions/orders/orderItems'
import Component from 'components/Orders/AddItems'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = (dispatch, props) => ({
  getJobs: (params) => dispatch(jobActions.getOptions({ pageIndex: 0, ...params })),
  getAssets: (params) => dispatch(assetActions.getOptions({ pageIndex: 0, ...params })),
  getOperators: (params) => dispatch(operatorActions.getOptions({ pageIndex: 0, ...params })),
  getProducts: (params) => dispatch(productActions.getItems({ pageIndex: 0, active: 'Active', ...params })),
  getTagLists: () => dispatch(tagListActions.getItemsOffline()),
  populateOrderItems: (params) => dispatch(orderItemActions.populateOrderItems(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
